<template>
  <div class="home-content-page-v prediction-source-page">
    <div class="content-1">
      <div class="gu-duan">
        <div>
          <el-select style="width: 10rem" v-model="selectArea" filterable size="small" placeholder="请选择区域">
            <el-option v-for="item in areaList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <el-select style="width: 10rem" v-model="selectOilType" size="small" placeholder="请选择油品">
            <el-option v-for="item in oilTypes" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div style="display:flex;">
          <a href="javascript:;" class="btm-btn" style="margin-right: 1rem;" @click="hxJxc">
            核销
          </a>
        </div>
        <div style="display:flex;">
          <a href="javascript:;" class="btm-btn" style="margin-right: 1rem;" v-if="errorHisJxcDatas.length > 0" @click="dialogVisible = true">
            错误数据调整
          </a>
          <a href="javascript:;" class="btm-btn" v-if="errorHisJxcDatas.length > 0" @click="hul">
            忽略
          </a>
        </div>
      </div>
      <div class="content-1-table-1 mii-table">
        <content-title :title="'进销存数据 ' + preDay"></content-title>
        <mii-table-oil :datas="showJxcDatas" :columns="jxcThs" :mergeRowKeyList="['加油站名称', '油品名称']"></mii-table-oil>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" size="large" :before-close="handleClose">
      <div class="content-1-table-1 mii-table">
        <content-title title="错误数据调整"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th v-for="th in tzThs">{{th.label}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index1) in errorHisJxcDatas">
              <td v-for="th in tzThs" :class="{'data-td': !(data[th.key] || {}).label, 's-bak-td': !(data[th.key] || {}).label && (index1 % 2 === 1), 'edit-td': canEditKey.indexOf(th.key) !== -1, 'edit-td-error': !checkData(data) && canEditKey.indexOf(th.key) !== -1, 'edit-td-success': checkData(data) && canEditKey.indexOf(th.key) !== -1}">
                <span :class="{'error-rk': (!checkRk(data)) && (th.key === '入库升数' || th.key === '配送计划')}">{{(data[th.key] || {}).label || data[th.key]}}</span>
                <input v-if="canEditKey.indexOf(th.key) !== -1" @focus="focusEdit(data, th.key)" type="text" class="edit-error-num" :class="{'error-rk': (!checkRk(data)) && th.key === '入库升数'}" v-model="edit_data" v-on:blur="blur(data, th.key)">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
        <el-button type="primary" @click="hul">全部忽略</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import ContentTitle from '@/components_bit/ContentTitle'
import MiiTableOil from '@/components_bit/MiiTableOil'
import {
  checkData,
  checkRkData
} from '@/cllib'

export default {
  name: 'cars',
  components: {
    ContentTitle,
    MiiTableOil
  },
  data () {
    return {
      selectOilType: '',
      oilTypes: ['汽油', '柴油'],
      selectArea: '',
      canEditKey: ['期初库存', '入库升数', '出库升数', '期末库存', '损溢', '配送计划'],
      tzThs: [{
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '油品类型',
        key: '油品名称'
      },
      {
        label: '时间',
        key: '日期'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '期初库存(L)',
        key: '期初库存'
      },
      {
        label: '入库升数(L)',
        key: '入库升数'
      },
      {
        label: '出库升数(L)',
        key: '出库升数'
      },
      {
        label: '期末库存(L)',
        key: '期末库存'
      },
      {
        label: '损溢(L)',
        key: '损溢'
      },
      {
        label: '平均销量(L)',
        key: '平均销量'
      },
      {
        label: '配送计划(L)',
        key: '配送计划'
      }],
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '油品类型',
        key: '油品名称'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '期初库存(L)',
        key: '期初库存'
      },
      {
        label: '入库升数(L)',
        key: '入库升数'
      },
      {
        label: '出库升数(L)',
        key: '出库升数'
      },
      {
        label: '期末库存(L)',
        key: '期末库存'
      },
      {
        label: '空容(L)',
        key: '空容'
      },
      {
        label: '损溢(L)',
        key: '损溢'
      },
      {
        label: '平均销量(L)',
        key: '平均销量'
      },
      {
        label: '物理容积(L)',
        key: '物理容积'
      },
      {
        label: '配送计划(L)',
        key: '配送计划'
      },
      {
        label: '在途(L)',
        key: '在途计划升数'
      }],
      edit_data: '',
      dialogVisible: false
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    checkData (data) {
      return checkData(data) === 0
    },
    hxJxc () {
      this.$store.dispatch('setHxDate', this.yesterDayStr)
      this.$store.dispatch('setAllPs', this.$store.getters.userInfo && this.$store.getters.userInfo.USER_TYPE === 'manager')
      this.$router.push({'name': 'single.ruku_check'})
      this.$store.dispatch('loadWaitHx')
    },
    checkRk (data) {
      let datas = []
      this.$store.getters.hisJxcDatas.forEach(function (itemData) {
        if (itemData.oil === data['加油站名称']) {
          datas = itemData.data
        }
      })
      return checkRkData(data, datas)
    },
    sure () {
      this.dialogVisible = false
      this.$store.dispatch('updateErrorHisJxcDatas')
    },
    hul () {
      this.dialogVisible = false
      this.$store.dispatch('hlErrorHisJxcDatas')
    },
    focusEdit (data, key) {
      let num = checkData(data)
      num = num === 0 ? data[key] : (['期初库存', '入库升数'].indexOf(key) === -1 ? Number(data[key]) + num : Number(data[key]) - num)
      this.edit_data = num < 0 && key !== '损溢' ? 0 : num
    },
    blur (data, key) {
      this.$store.dispatch('editOneHisJxcData', {data, key, value: this.edit_data})
      this.edit_data = ''
    }
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.flowStatus === 0) {
      next({name: 'single.source_data_pre'})
    } else {
      next()
    }
  },
  computed: {
    showJxcDatas: {
      get () {
        let datas = []
        this.$store.getters.hisJxcDatas.forEach((item) => {
          item['data'].forEach((itemD) => {
            if ((!this.selectArea || (itemD['区域'] && itemD['区域'].indexOf(this.selectArea) > -1)) && (!this.selectOilType || (itemD['油品名称'] && itemD['油品名称'].indexOf(this.selectOilType) > -1))) {
              datas.push(itemD)
            }
          })
        })
        return datas
      }
    },
    preDay: {
      get () {
        return this.$store.getters.todayStr
      }
    },
    yesterDayStr: {
      get () {
        return this.$store.getters.yesterDayStr
      }
    },
    errorHisJxcDatas: {
      get () {
        return this.$store.getters.errorHisJxcDatas
      }
    },
    areaList: {
      get () {
        return this.$store.getters.allAreas
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.error-rk {
  color: #f7bd34 !important;
}
.edit-td:hover {
  input {
    display: block;
  }
  span {
    display: none;
  }
}
.btm-btn {
  border-radius: 0.25rem;
  background-color: #ffa022;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.7rem;
  letter-spacing: 1px;
  color: #fff;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
}
.edit-td-error {
  color:  #f7bd34 !important;
}
.edit-td-success {
  color: #14cf65 !important;
}
.edit-td {
  width: 7rem;
  text-align: center;
  input {
    width: 6rem;
    margin: 0 auto;
    text-align: center;
    display: none;
  }
  span {
    display: block;
  }
}
.edit-error-num {
  width: 5rem;
}

.gu-duan {
  margin-bottom:0.7em;
  width: 100%;
  .el-select {
    width: 25em;
  }
  display: flex;
  justify-content: space-between;
}
.content-1 {
  border-radius: 0.5em;
  padding: 0.88em 0.7em 2.25em;
  background-color: #e5e5e5;
  display: block;
}
.content-1-tables {
  display: flex;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table {
  .content-shadow;
  .content-top-radius;
  display: flex;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  .s-bak-td {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
  .jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
  table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
    }
    td {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
    }
  }
}
</style>

<style lang="less">
.prediction-source-page {
  .el-scrollbar__wrap {
    overflow:visible;
  }
  .el-scrollbar {
    overflow:visible;
  }
  .el-select-dropdown {
    overflow: scroll
  }
}
</style>



// WEBPACK FOOTER //
// prediction_check.vue?2dfc9dee